<template>
    <v-container class="py-5">
        <v-breadcrumbs :items="breadcrumbs" large></v-breadcrumbs>

        <!-- <v-alert type="info" v-if="userList.length>=points">
            Se le permite tener {{ points }} usuarios como puntos de venta.
        </v-alert> -->

        <v-row>
            <v-col cols="12" md="4">
                <v-form @submit.prevent="register" ref="refRegister" lazy-validation>
                    <v-card :loading="loading">
                        <v-card-title>
                            Crear nuevo usuario
                        </v-card-title>
                        <v-card-text>
                            <!-- name -->
                            <v-text-field
                                label="Nombre(s) *"
                                outlined
                                dense
                                v-model="data.name"
                                :rules="[rules.required]"
                                :error="errors['name'] ? true :false"
                                :error-messages="errors['name'] ? errors['name'][0] : ''"
                            ></v-text-field>
                            <!-- end name -->
                            <!-- email -->
                            <v-text-field
                                label="Correo electrónico *"
                                outlined
                                dense
                                type="email"
                                v-model="data.email"
                                :rules="[rules.required, rules.email]"
                                :error="errors['email'] ? true :false"
                                :error-messages="errors['email'] ? errors['email'][0] : ''"
                            ></v-text-field>
                            <!-- end email -->
                            
                            <!-- role -->
                            <v-select
                                :items="itemsRole"
                                item-text="name"
                                item-value="id"
                                label="Rol *"
                                outlined
                                dense
                                v-model="data.role"
                                :rules="[rules.required]"
                                :error="errors['role'] ? true :false"
                                :error-messages="errors['role'] ? errors['role'][0] : ''"
                                @change="data.code_login = ''"
                            ></v-select>
                            <!-- end role -->

                            <!-- code login -->
                            <v-text-field
                                v-if="data.role == 'waiter-6'"
                                label="Codigo de login (opcional)"
                                outlined
                                dense
                                v-model="data.code_login"
                                :error="errors['code_login'] ? true :false"
                                :error-messages="errors['code_login'] ? errors['code_login'][0] : ''"
                                @input="formateAlphaNumeric($event)"
                            ></v-text-field>

                            <!-- password -->
                            <v-flex xs12 v-if="data.role != 'waiter-6'">
                                <div class="input-container d-flex">
                                    <v-text-field
                                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="show1 ? 'text' : 'password'"
                                        label="Contraseña *"
                                        hint="Mínimo 8 caracteres"
                                        counter
                                        dense
                                        outlined
                                        v-model="data.password"
                                        :rules="[rules.required, rules.min]"
                                        :error="errors.password ?true :false"
                                        :error-messages="errors['password'] ? errors['password'][0] : ''"
                                        @click:append="show1 = !show1"
                                    ></v-text-field>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                class="ml-2"
                                                fab
                                                dark
                                                small
                                                color="primary"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="data.password = genRandom()"
                                            >
                                                <v-icon dark>
                                                    mdi-reload
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Generar contraseña</span>
                                    </v-tooltip>
                                </div>
                            </v-flex>
                            <!-- end password -->

                            <div v-if="data.role == 'waiter-6'">
                                <p>
                                    Link ingreso meseros: <br>
                                    <a :href="`/${slug}/login-waiter`" target="_blank">
                                        {{ `/${slug}/login-waiter` }}
                                        <v-icon small color="primary">
                                            mdi-open-in-new
                                        </v-icon>
                                    </a>
                                </p>
                            </div>

                            <v-alert
                                type="info"
                                dense
                                text
                                v-if="points > 0 || preventist > 0"
                            >
                                Se adminte {{ points }} Puntos de venta <br>
                                Se admite {{ preventist }} preventista
                            </v-alert>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                outlined
                                color="error"
                                :disabled="loading"
                                @click="clearData"
                            >Cancelar</v-btn>
                            <v-btn
                                type="submit"
                                color="primary"
                                :loading="loading"
                            >Registrar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-col>

            <!-- card main -->
            <v-col cols="12" md="8">
                <v-card>
                    <v-card-title class="blue-grey darken-4 white--text">
                        <div>Lista de usuarios</div>
                        <v-spacer></v-spacer>
                        <form @submit.prevent="processSearch" class="d-flex align-center">
                            <v-text-field
                                v-model="txtSearch"
                                placeholder="Buscar..."
                                outlined
                                dense
                                hide-details
                                type="text"
                                dark
                                @keyup="processSearch"
                            ></v-text-field>
                            <v-btn
                                color="red"
                                icon
                                large
                                v-show="txtSearch !== ''"
                                @click="cleanSearch"
                                class="ml-2"
                            >
                                <v-icon dark>
                                    mdi-close
                                </v-icon>
                            </v-btn>
                        </form>
                    </v-card-title>

                    <v-card-text>
                        <v-simple-table>
                            <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left text-uppercase">
                                        Nombre
                                    </th>
                                    <th class="text-left text-uppercase">
                                        Email
                                    </th>
                                    <th class="text-left text-uppercase">
                                        Rol
                                    </th>
                                    <th class="text-right text-uppercase">
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in userList" :key="index">
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.email }}</td>
                                    <td>{{ item.store_roles?.length > 0 ? item.store_roles[0].name : item.role?.description }}</td>
                                    <td class="text-right">
                                        <div class="d-flex justify-end">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        icon
                                                        @click="editUser(item.id)"
                                                    >
                                                        <v-icon color="grey">
                                                            mdi-pencil
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Editar</span>
                                            </v-tooltip>

                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        icon
                                                        @click="deleteUser(item.id)"
                                                    >
                                                        <v-icon color="grey">
                                                            mdi-delete
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Eliminar</span>
                                            </v-tooltip>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
                <div class="text-right py-2" v-html="pageTable"></div>
                <v-pagination
                    v-model="page"
                    :length="totalPage"
                    :total-visible="5"
                    color="primary"
                    @input="changePage"
                    class="my-5"
                ></v-pagination>
            </v-col>
            <!-- end card main -->
        </v-row>

        <!-- dialog edit -->
        <v-dialog
            v-model="dialogEdit"
            max-width="400px"
            scrollable
        >
            <v-form @submit.prevent="edit" ref="refEdit" lazy-validation>
                <v-card :loading="loading">
                    <v-card-title>
                        Editar usuario
                    </v-card-title>
                    <v-card-text class="pt-3">
                        <!-- name -->
                        <v-text-field
                            label="Nombre(s) *"
                            outlined
                            dense
                            v-model="data2.name"
                            :rules="[rules.required]"
                            :error="errors['name'] ? true :false"
                            :error-messages="errors['name'] ? errors['name'][0] : ''"
                        ></v-text-field>
                        <!-- end name -->
                        <!-- email -->
                        <v-text-field
                            label="Correo electrónico *"
                            outlined
                            dense
                            type="email"
                            v-model="data2.email"
                            :rules="[rules.required, rules.email]"
                            :error="errors['email'] ? true :false"
                            :error-messages="errors['email'] ? errors['email'][0] : ''"
                        ></v-text-field>
                        <!-- end email -->

                        <!-- code login -->
                        <v-text-field
                            v-if="data2.role?.description == 'Mesero'"
                            label="Codigo de login (opcional)"
                            outlined
                            dense
                            v-model="data2.code_login"
                            :error="errors['code_login'] ? true :false"
                            :error-messages="errors['code_login'] ? errors['code_login'][0] : ''"
                            @input="formateAlphaNumeric($event, 'edit')"
                        ></v-text-field>

                        <!-- password -->
                        <v-flex xs12 v-if="data2.role?.description != 'Mesero'">
                            <div class="input-container d-flex">
                                <v-text-field
                                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                    :type="show1 ? 'text' : 'password'"
                                    label="Nueva contraseña"
                                    hint="Mínimo 8 caracteres"
                                    counter
                                    dense
                                    outlined
                                    v-model="data2.password"
                                    :error="errors.password ?true :false"
                                    :error-messages="errors['password'] ? errors['password'][0] : ''"
                                    @click:append="show1 = !show1"
                                ></v-text-field>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            class="ml-2"
                                            fab
                                            dark
                                            small
                                            color="primary"
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="data2.password = genRandom()"
                                        >
                                            <v-icon dark>
                                                mdi-reload
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Generar contraseña</span>
                                </v-tooltip>
                            </div>
                        </v-flex>
                        <!-- end password -->
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="error"
                            text
                            @click="dialogEdit = false"
                            :disabled="loading"
                        >
                            Cancelar
                        </v-btn>
                        <v-btn
                            color="primary"
                            :loading="loading"
                            type="submit"
                        >
                            Actualizar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- end dialog edit -->

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->
    </v-container>
</template>
<script>
export default {
    data() {
        return {
            overlay: false,
            loading: false,
            show1: true,
            breadcrumbs: [
                {
                    text: 'Usuarios',
                    disabled: true,
                    href: '',
                }
            ],
            itemsRole: [],
            // create user
            data: {
                name: '',
                email: '',
                password: this.genRandom(),
                role: '',
                code_login: ''
            },
            // user list
            userList: [],
            pageTable: '',
            page: 1,
            totalPage: null,
            txtSearch: '',
            // edit
            dialogEdit: false,
            data2: {
                id: '',
                name: '',
                email: '',
                password: '',
                role: '',
                code_login: ''
            },
            // delete
            deleteId: '',
            // validation
            rules: {
                required: v => !!v || 'El campo es obligatorio',
                min: v => v.length >= 8 || 'Mínimo 8 caracteres',
                phone: v => (v.length >= 12 && v.length <= 12) || 'Debe contener 12 dígitos',
                email: v => /.+@.+\..+/.test(v) || 'Email inválido'
            },
            errors: {},
        }
    },
    props: ['points', 'preventist', 'typeStore', 'slug'],
    mounted() {
        this.getUserList()
        this.getRoleList()

        if (this.points > 0) {
            this.itemsRole.push({name:'Punto de venta', id:'sales-4'})
        }

        if (this.preventist > 0) {
            this.itemsRole.push({name:'Preventista', id:'sales-5'})
        }

        if (this.typeStore == 'gastronomic') {
            this.itemsRole.push({name:'Mesero', id:'waiter-6'})
        }
    },
    methods: {
        /**
         * generate password
         */
        genRandom () {
            var result = '';
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < 10; i++ ) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result
            // this.data.password = result
        },
        formateAlphaNumeric (e, type = 'create') {
            if (type == 'create') {
                this.data.code_login = e.replace(/[^a-zA-Z0-9]/g, '');
            } else {
                this.data2.code_login = e.replace(/[^a-zA-Z0-9]/g, '');
            }
        },
        /**
         * User list
         */
        processSearch () {
            this.page = 1
            this.getUserList()
        },
        changePage (event) {
            this.page = event;
            this.getUserList()
        },
        cleanSearch () {
            if (this.txtSearch !== '') {
                this.userList = []
                this.page = 1
                this.txtSearch = ''
                this.getUserList();
            }
        },
        async getUserList () {
            this.userList = []
            this.overlay = true
            await axios.get(`/admin/user-list?page=${this.page}&search=${this.txtSearch}`)
            .then(response => {
                // console.log(response)
                this.userList = response.data.data
                this.totalPage = response.data.last_page
                this.pageTable = `Showing <strong>${response.data.from??0} - ${response.data.to??0}</strong> of a total of <strong>${response.data.total}</strong>`
                this.overlay = false
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error del servidor, inténtalo de nuevo más tarde.');
                }
                this.overlay = false
            })
        },

        /**
         * Register
         */
        async register () {
            if (this.$refs.refRegister.validate()) {
                this.errors = {}
                this.loading = true
                const formData = new FormData
                formData.append('name', this.data.name)
                formData.append('email', this.data.email)
                formData.append('password', this.data.password)
                formData.append('role', this.data.role)
                formData.append('code_login', this.data.code_login)
                await axios.post('/admin/my-users', formData)
                .then(response => {
                    // console.log(response)
                    if (response.data == 'ok') {
                        this.$alert('', 'Registro exitoso.', 'success', {confirmButtonText: 'Continue'})
                        this.getUserList()
                        // reset
                        this.clearData()
                    }
                    this.loading = false
                })
                .catch(error => {
                    // console.log(error)
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert('Error del servidor, inténtalo de nuevo más tarde.');
                    }
                    if (error.response.status == 401) {
                        this.$alert('Llegó al límite de usuarios permitidos.');
                    }
                    this.loading = false
                })
            }
        },
        clearData() {
            this.$refs.refRegister.resetValidation()
            this.data.name = ''
            this.data.email = ''
            this.data.password = this.genRandom()
            this.data.role = ''
            this.data.code_login = ''
        },

        /**
         * Editar
         */
        editUser (id) {
            var tmpData = this.userList.filter(item => item.id === id)[0]

            this.data2.id = tmpData.id
            this.data2.name = tmpData.name
            this.data2.email = tmpData.email
            this.data2.role = tmpData.role
            this.data2.code_login = tmpData.code_login

            this.dialogEdit = true
        },
        async edit () {
            if (this.$refs.refEdit.validate()) {
                this.errors = {}
                this.loading = true
                const formData = new FormData
                formData.append('name', this.data2.name)
                formData.append('email', this.data2.email)
                formData.append('password', this.data2.password)
                formData.append('code_login', this.data2.code_login)
                formData.append('_method', 'PUT')

                await axios.post(`/admin/my-users/${this.data2.id}`, formData)
                .then(response => {
                    // console.log(response)
                    if (response.data == 'ok') {
                        this.$alert('', 'Datos actualizados con éxito.', 'success', {confirmButtonText: 'Continue'})
                        this.getUserList()
                        this.dialogEdit = false
                        // reset
                        this.data2.password = ''
                        this.$refs.refEdit.resetValidation()
                    }
                    this.loading = false
                })
                .catch(error => {
                    // console.log(error)
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert('Error del servidor, inténtalo de nuevo más tarde.');
                    }
                    this.loading = false
                })
            }
        },

        /**
         * Delete
         */
        deleteUser (id) {
            this.$confirm(
                'Se eliminará permanentemente del sistema',
                '¿Eliminar usuario?',
                'info', {
                showCloseButton: true,
                reverseButtons: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar',
            }).then(res => {
                if (res) {
                    axios.delete(`/admin/my-users/${id}`)
                    .then(response => {
                        // console.log(response);
                        if (response.data == 'ok') {
                            this.$alert('', 'Usuario eliminado exitosamente.', 'success', {confirmButtonText: 'Continue'})
                            this.getUserList()
                        }
                    })
                    .catch(error => {
                        // console.log(error)
                        if (error.response.status == 404 || error.response.status == 500) {
                            this.$alert('Error del servidor, inténtalo de nuevo más tarde.');
                        }
                    })
                }
            });
        },

        /**
         * roles de la tienda
         */
        async getRoleList () {
            this.overlay = true
            await axios.get(`/admin/role-list?page=${this.page}&search=${this.txtSearch}&paginate=not`)
            .then(response => {
                // console.log(response)
                response.data.forEach(element => {
                    this.itemsRole.push({name: element.name, id: element.id})
                });
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error del servidor, inténtalo de nuevo más tarde.');
                }
                this.overlay = false
            })
        },
    }
}
</script>
